/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC, useState} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import {useLang, setLanguage} from '../../../i18n/Metronici18n'
import {useIntl} from 'react-intl'
import { Account } from './../../../../app/modules/profile/components/account/Account';
import { AccountSettingDialog } from './AccountSettingDialog'


const AccountSetting: FC = () => {
  const lang = useLang()
  const intl = useIntl()
  const [shoundOpenDialog,setShouldOpenDialog]= useState<boolean>(false)
  return (
    <div
      className='menu-item px-5'
      data-kt-menu-trigger='hover'
      data-kt-menu-placement='left-start'
      data-kt-menu-flip='bottom'
    >
      <a href='#' className='menu-link px-5'>
        <span className='menu-title position-relative'>
                Cài đặt tài khoản
        
        </span>
      </a>

      <div className='menu-sub menu-sub-dropdown w-175px py-4'>
      
          <div
            className='menu-item px-3'
         
          
          >
            <div
            onClick={()=>setShouldOpenDialog(true)}
              className={clsx('menu-link d-flex px-5')}
            >
           
              Đổi mật khẩu
            </div>
          </div>
     
      </div>
      {shoundOpenDialog&&<AccountSettingDialog handleClose={()=>setShouldOpenDialog(false)}/>}
    </div>
  )
}

export {AccountSetting}
